interface Props {
  message?: string | null;
  className?: string;
}

/** Inline form error in the app's standard rose-600 small text. Renders nothing when `message` is falsy. */
export function ErrorMessage({ message, className = '' }: Props) {
  if (!message) return null;
  return <p className={`text-sm text-rose-600 ${className}`.trim()}>{message}</p>;
}
